import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=7900d5aa&"
import script from "./DetailReceipt.vue?vue&type=script&lang=js&"
export * from "./DetailReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports